import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useManagers() {
  const [loading, setLoading] = useState(true);
  const [managers, setManagers] = useState([]);

  useEffect(() => {
    axios
      .get(routes.api.managers.index)
      .then((response) => {
        setManagers(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, managers };
}
